<template>
  <div class="CheckDropDownContainer" v-bind:style="styleWidth" v-bind:title="this.title">
    <div
      class="CheckDropDownSelectedItems"
      @click.capture="CheckDropDownClick($event)"
      contenteditable="true"
      v-on:keydown="ddlKeyDown($event)"
      :multiline="multiline"
      :style="{maxHeight:maxHeight}"
    >
      <div
        @click.prevent.stop
        class="chkedItem"
        v-for="x in this.checkedItems"
        v-bind:key="x[valueField]"
      >
        {{x[textField]}}
        <a class="removeItem" @click.stop="removeItem" :itemid="x[valueField]">x</a>
      </div>
    </div>
    <div
      class="CheckDropDownSelectionCount"
      @click.stop="CheckDropDownClick($event)"
      v-bind:tmptitle="this.countToolTip"
    >{{this.checkCount}}</div>
    <div class="CheckDropDownListBox" @click.stop>
      <div class="CheckDropDownSearch glyphicons search">
        <input type="search" v-on:input="txtSearchOnInput($event)" v-on:keydown="onKeyDown($event)" />
      </div>
      <div class="CheckDropDownList">
        <label
          class="CheckDropDownListItem"
          v-for="listItem in listData"
          v-bind:key="listItem[valueField]"
          v-bind:searchkey="listItem[searchField||textField].toLowerCase()"
        >
          <input type="checkbox" v-model="listItem[checkField]" />
          {{listItem[textField]}}
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    listData: { type: Array, required: true },
    valueField: { type: String, default: "value" },
    textField: { type: String, default: "text" },
    checkField: { type: String, default: "checked" },
    multiline: { type: String, default: "false" },
    maxHeight: { type: String, default: "" },
    searchField: String,
    title: String,
    width: String
  },
  data() {
    return {};
  },
  methods: {
    CheckDropDownClick(e) {
      if (e.target.classList.contains("removeItem")) {
        return;
      }
      let obj = e.target;
      let CheckDropDownContainer = e.target.closest(".CheckDropDownContainer");
      let CheckDropDownListBox = CheckDropDownContainer.querySelector(
        ".CheckDropDownListBox"
      );
      // document
      //   .querySelectorAll(".CheckDropDownListBox")
      //   .not(CheckDropDownListBox)
      //   .hide();
      // document.querySelectorAll(".SearchDropDownListBox").hide();
      if (CheckDropDownListBox.isVisible()) {
        CheckDropDownListBox.hide();
      } else {
        CheckDropDownListBox.showAsDropDown(CheckDropDownContainer);
        let documentBodyClick = function(e) {
          if (e.target !== obj) {
            CheckDropDownListBox.hide();
          } else {
            document.body.one("click", documentBodyClick);
          }
        };
        document.body.one("click", documentBodyClick);

        let txtSearch = CheckDropDownListBox.querySelector(
          'input[type="search"]'
        );
        txtSearch.focus();
      }
    },
    removeItem(e) {
      let itemid = e.target.getAttribute("itemid");
      for (let i = 0; i < this.listData.length; i++) {
        if (this.listData[i][this.valueField] == itemid) {
          this.listData[i][this.checkField] = false;
        }
      }
    },
    txtSearchOnInput(e) {
      let searchText = e.target.value;
      let searchKeys = searchText.split(" ");
      let selectorFilter = "";
      for (let i = 0; i < searchKeys.length; i++) {
        if (searchKeys[i].length > 2) {
          selectorFilter += '[searchkey*="' + searchKeys[i] + '"]';
        }
      }
      let CheckDropDownContainer = e.target.closest(".CheckDropDownContainer");
      let CheckDropDownList = CheckDropDownContainer.querySelector(
        ".CheckDropDownList"
      );

      if (selectorFilter.length > 0) {
        CheckDropDownList.querySelectorAll(".CheckDropDownListItem").hide();
        CheckDropDownList.querySelectorAll(
          ".CheckDropDownListItem" + selectorFilter
        ).show();
      } else {
        CheckDropDownList.querySelectorAll(".CheckDropDownListItem").show();
      }
    },
    onKeyDown(e) {
      if (e.which === 38) {
        let CheckDropDownList = e.target
          .closest(".CheckDropDownListBox")
          .querySelector(".CheckDropDownList");
        let selectedItem = CheckDropDownList.querySelector(
          ".CheckDropDownListItem[selected]"
        );
        if (!selectedItem) {
          selectedItem = CheckDropDownList.querySelector(
            ".CheckDropDownListItem"
          );
        }
        if (selectedItem) {
          let previousElementSibling = selectedItem.previousElementSibling;
          while (
            previousElementSibling &&
            !previousElementSibling.isVisible()
          ) {
            previousElementSibling =
              previousElementSibling.previousElementSibling;
          }
          if (previousElementSibling) {
            previousElementSibling.setAttribute("selected", "selected");
            selectedItem.removeAttribute("selected");
            if (
              previousElementSibling.offsetTop <
              CheckDropDownList.scrollTop + 30
            ) {
              previousElementSibling.scrollIntoView(true);
            }
          }
        }
      } else if (e.which === 40) {
        let CheckDropDownList = e.target
          .closest(".CheckDropDownListBox")
          .querySelector(".CheckDropDownList");
        let selectedItem = CheckDropDownList.querySelector(
          ".CheckDropDownListItem[selected]"
        );
        if (!selectedItem) {
          selectedItem = CheckDropDownList.querySelector(
            ".CheckDropDownListItem"
          );
        }
        if (selectedItem) {
          let nextElementSibling = selectedItem.nextElementSibling;
          while (nextElementSibling && !nextElementSibling.isVisible()) {
            nextElementSibling = nextElementSibling.nextElementSibling;
          }
          if (nextElementSibling) {
            nextElementSibling.setAttribute("selected", "selected");
            selectedItem.removeAttribute("selected");
            if (
              nextElementSibling.offsetTop >
              CheckDropDownList.scrollTop + CheckDropDownList.offsetHeight - 30
            ) {
              nextElementSibling.scrollIntoView(false);
            }
          }
        }
      } else if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        let CheckDropDownContainer = e.target.closest(
          ".CheckDropDownContainer"
        );
        let CheckDropDownList = CheckDropDownContainer.querySelector(
          ".CheckDropDownList"
        );
        let selectedItem = CheckDropDownList.querySelector(
          ".CheckDropDownListItem[selected]"
        );
        let el = selectedItem;
        let i = 0;
        while (el) {
          el = el.previousElementSibling;
          i++;
        }
        this.listData[i - 1][this.checkField] = !this.listData[i - 1][
          this.checkField
        ];
      } else if (e.which === 27 || e.which === 9) {
        e.target.closest(".CheckDropDownListBox").hide();
        e.target
          .closest(".CheckDropDownContainer")
          .querySelector(".CheckDropDownSelectedItems")
          .focus();
      }
    },
    ddlKeyDown(e) {
      if (e.which !== 9 && e.which !== 27) {
        let CheckDropDownContainer = e.target.parentNode;
        let CheckDropDownListBox = CheckDropDownContainer.querySelector(
          ".CheckDropDownListBox"
        );
        CheckDropDownListBox.showAsDropDown(CheckDropDownContainer);
        document.body.one("click", function() {
          CheckDropDownListBox.hide();
        });
        let txtSearch = CheckDropDownListBox.querySelector(
          'input[type="search"]'
        );
        txtSearch.focus();
      }
    }
  },
  computed: {
    styleWidth() {
      return ";width:" + (this.width ? this.width : "");
    },
    checkCount() {
      let c = 0;
      this.listData.forEach(x => {
        if (x[this.checkField]) {
          c++;
        }
      });
      return c;
    },
    countToolTip() {
      if (this.checkCount > 0) {
        let toolTip = "<div style='padding-left:20px;'><ol>";
        this.listData.forEach(x => {
          if (x[this.checkField]) {
            toolTip += "<li>" + x[this.textField] + "</li>";
          }
        });
        toolTip += "</ol></div>";
        return toolTip;
      } else {
        return "No Item Selected";
      }
    },
    checkedItems() {
      let chkList = [];
      this.listData.forEach(x => {
        if (x[this.checkField]) {
          chkList.push(x);
        }
      });
      return chkList;
    }
  }
};
</script>
<style scoped>
.CheckDropDownContainer {
  color: #000;
  border: solid 1px;
  border-radius: 4px;
  position: relative;
  background-color: #f5f5f5;
  box-shadow: inset 0 2px 3px rgba(0, 0, 0, 0.2);
  display: flex;
}
.CheckDropDownSelectedItems {
  padding: 3px;
  flex-grow: 1;
  flex-shrink: 1;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
}

.CheckDropDownSelectedItems:empty:before {
  content: "Click to Check Some Items From CheckBoxList";
  color: #bfbfbf;
}
.CheckDropDownSelectedItems[multiline="true"] {
  flex-wrap: wrap;
  overflow: auto;
}
.CheckDropDownSelectedItems:empty {
  overflow: hidden;
}
.chkedItem .removeItem {
  opacity: 0;
  transition: all 800ms;
  padding: 0px 3px;
  color: red;
}
.chkedItem:hover .removeItem {
  opacity: 1;
}

.CheckDropDownSelectionCount {
  flex-grow: 0;
  flex-shrink: 0;
  padding: 3px;
  background-color: green;
  color: white;
  width: 30px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  font-weight: bold;
}
.CheckDropDownListBox {
  width: 100%;
  border: solid 1px;
  background-color: #fff;
  color: #000;
  position: fixed;
  display: none;
  z-index: 1;
}
.CheckDropDownSearch {
  padding: 5px;
  position: relative;
  width: 100%;
}
.CheckDropDownSearch:before {
  position: absolute;
  left: 10px;
}
.CheckDropDownSearch input[type="search"] {
  padding-left: 25px;
}
.CheckDropDownList {
  width: 100%;
  border: solid 1px;
  max-height: 200px;
  overflow: auto;
}
.CheckDropDownListItem {
  display: block;
  padding: 3px;
  border: solid 1px #bfbfbf;
  cursor: default;
}
.CheckDropDownListItem:hover {
  background-color: #bfbfbf;
}
.CheckDropDownListItem[selected="selected"] {
  background-color: rgb(40, 40, 247);
  color: white;
}
.CheckDropDownListItem[hidden] {
  display: none;
}
.chkedItem {
  border: solid 1px red;
  border-radius: 3px;
  margin-right: 1px;
  margin: 0 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/CheckDropDown.vue